import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

import Moment from 'react-moment';
import moment from 'moment';
import { map } from 'lodash';

import Pagination from 'reactstrap/lib/Pagination';
import PaginationItem from 'reactstrap/lib/PaginationItem';
import PaginationLink from 'reactstrap/lib/PaginationLink';
import * as constants from '../../../constants/constants';
import DateFormat from '../UI/DateFormat';
import { Button, PopoverBody, UncontrolledPopover } from 'reactstrap';

class AdminActionLogs extends React.Component {
  static propTypes = {
    fetchAdminActionLog: PropTypes.func.isRequired,
    logsCount: PropTypes.number,
    adminActionData: PropTypes.shape({}),
    t: PropTypes.func.isRequired,
  }

  static defaultProps = {
    logsCount: 0,
    adminActionData: {},
  }

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      pageSize: 50,
      expandedContent: {},
      tooltipOpen: {},
    };
    this.handleClick = this.handleClick.bind(this);
    this.toggleContentExpansion = this.toggleContentExpansion.bind(this);
  }

  componentDidMount() {
    const { fetchAdminActionLog, logsCount } = this.props;

    const start = logsCount - 49;
    const end = logsCount;

    // fetchAdminActionLog(start, end);
    if (logsCount !== 0) {
      fetchAdminActionLog(start, end);
    }
  }
  componentDidUpdate(prevProps) {
    const { logsCount, fetchAdminActionLog } = this.props;
    if (logsCount !== 0 && logsCount !== prevProps.logsCount) {
      const start = logsCount - 49;
      const end = logsCount;
      fetchAdminActionLog(start, end);
    }
  }

  handleClick = (e, index) => {
    e.preventDefault();
    const { fetchAdminActionLog, logsCount } = this.props;

    const start = logsCount - (50 * index) - 49;
    const end = logsCount - (50 * index);

    fetchAdminActionLog(start, end);

    this.setState({
      currentPage: index,
    });
  }

  toggleContentExpansion = (key) => {
    this.setState(prevState => ({
      expandedContent: {
        ...prevState.expandedContent,
        [key]: !prevState.expandedContent[key]
      }
    }));
  }

  truncateContent = (content, maxLength = 100) => {
    if (!content) {
      return { content: '', isExpandable: false };
    }
    const isExpandable = content.length > maxLength;
    const truncatedContent = isExpandable ? `${content.substring(0, maxLength)}...` : content;

    return {
      content: truncatedContent,
      isExpandable
    };
  }

  truncateMultipleContents = (contents, maxLength = 100) => {
    if (!contents || contents.length === 0) {
      return { contents: [], isExpandable: false };
    }

    // Calculate total length of all contents combined
    const totalLength = contents.reduce((sum, content) => sum + (content?.length || 0), 0);
    const isExpandable = totalLength > maxLength;

    if (!isExpandable) {
      return { contents, isExpandable: false };
    }

    // If expandable, truncate the combined content
    let accumulatedLength = 0;
    const truncatedContents = [];

    for (let i = 0; i < contents.length; i++) {
      const content = contents[i] || '';
      const remainingLength = maxLength - accumulatedLength;

      if (accumulatedLength >= maxLength) {
        // Already exceeded limit, don't add more
        break;
      } else if (accumulatedLength + content.length <= maxLength) {
        // This content fits entirely
        truncatedContents.push(content);
        accumulatedLength += content.length;
      } else {
        // This content needs to be truncated
        const truncated = content.substring(0, remainingLength - 3) + '...';
        truncatedContents.push(truncated);
        accumulatedLength = maxLength;
        break;
      }
    }

    return {
      contents: truncatedContents,
      isExpandable: true
    };
  }

  hasExpandableContent = (item) => {
    if (!item) return false;

    // Collect all content strings and calculate total length
    const allContents = [];

    constants.adminActionTypes.forEach(actionType => {
      if (actionType.id === item.type) {
        actionType.changeKey.forEach((keyData) => {
          let content;
          if (actionType.changeData === constants.adminActionTypesData) {
            content = `${keyData}: ${(item && item.data) ? ((item.type === 'editAnnouncement' || item.type === 'addNewAnnouncement') ?
              (item.data[keyData]?.en) : (item.data[keyData])) : ''} ,`;
          } else {
            content = `${keyData}: ${item ? item[keyData] : ''} ,`;
          }
          allContents.push(content);
        });
      }
    });

    const totalLength = allContents.reduce((sum, content) => sum + (content?.length || 0), 0);
    return totalLength > 100;
  }

  toggleTooltip = (item, key) => {
    console.log('toggleTooltip 1', item, key);
    if (this.hasExpandableContent(item)) {
      this.setState(prevState => ({
        tooltipOpen: {
          ...prevState.tooltipOpen,
          [key]: true
        }
      }));
    } else {
      this.setState(prevState => ({
        tooltipOpen: {
          ...prevState.tooltipOpen,
          [key]: false
        }
      }));
    }
  }

  table = () => {
    const {
      adminActionData,
      logsCount,
      offset,
    } = this.props;
    const {
      currentPage,
      pageSize,
    } = this.state;

    console.log('adminActionData', adminActionData);
    const sortedAdminActionData = Object.keys(adminActionData).sort().reverse().reduce((obj, key2) => {
      obj[key2] = adminActionData[key2];
      return obj;
    }, {});
    if (adminActionData) {
      const pagesCount = Math.ceil(logsCount / pageSize);
      return (
        <Fragment>
          {sortedAdminActionData && map(sortedAdminActionData, (item, key) => (
            <Fragment key={key}>
              <tr
                key={key}
                className={`admin-action-log-row ${item.type}`}
                style={{ backgroundColor: `${constants.adminActionTypes.filter(actionType => actionType.id === item.type)[0] ? constants.adminActionTypes.filter(actionType => actionType.id === item.type)[0].bgColor.toString() : '#f9803057'}` }}
              >
                <td className="allUsers-table-col">
                  { item.adminEmail || item.adminId}
                </td>
                <td className="allUsers-table-col">
                  { item.adminName }
                </td>
                <td className="allUsers-table-col">
                  { item.type }
                </td>
                <td
                  className="allUsers-table-col content-cell"
                  style={{
                    wordWrap: 'break-word',
                    position: 'relative',
                    padding: '8px'
                  }}
                  onClick={() => this.toggleContentExpansion(key)}
                  onMouseEnter={() => this.toggleTooltip(item, key)}
                  title={this.state.tooltipOpen[key] ? "Click to expand/collapse content" : undefined}
                >
                  <div style={{
                    whiteSpace: this.state.expandedContent[key] ? 'normal' : 'nowrap',
                    position: 'relative'
                  }}>
                    {(() => {
                      // First, collect all content strings
                      const allContents = [];
                      const contentKeys = [];

                      constants.adminActionTypes.forEach(actionType => {
                        if (actionType.id === item.type) {
                          actionType.changeKey.forEach((keyData) => {
                            let content;
                            if (actionType.changeData === constants.adminActionTypesData) {
                              content = `${keyData}: ${(item && item.data) ? ((item.type === 'editAnnouncement' || item.type === 'addNewAnnouncement') ?
                                (item.data[keyData]?.en) : (item.data[keyData])) : ''} ,`;
                            } else {
                              content = `${keyData}: ${item ? item[keyData] : ''} ,`;
                            }
                            allContents.push(content);
                            contentKeys.push(keyData);
                          });
                        }
                      });

                      // Truncate combined content
                      const truncatedResult = this.truncateMultipleContents(allContents, 100);
                      const isExpandable = truncatedResult.isExpandable;
                      const isExpanded = this.state.expandedContent[key];

                      // Render spans
                      return contentKeys.map((keyData, index) => {
                        const fullContent = allContents[index];
                        const truncatedContent = truncatedResult.contents[index] || '';
                        const displayContent = isExpanded ? fullContent : truncatedContent;

                        return (
                          <span
                            className={isExpandable ? 'cursor-pointer' : 'cursor-default'}
                            key={keyData}
                          >
                            {displayContent}
                          </span>
                        );
                      });
                    })()}
                  </div>
                </td>
                <td className="allUsers-table-col">
                  <DateFormat formatType={constants.FORMAT_DATE_TYPE.fullDateMinute} date={item.date + offset} />
                </td>
                <td className="allUsers-table-col">
                  { item.userId || ''}
                </td>
                <td className="allUsers-table-col">
                  { item.userName || '' }
                </td>
              </tr>
            </Fragment>
          ))}
          {pagesCount && logsCount > pageSize && (
          <div className="pagination-wrapper">
            <Pagination aria-label="Page navigation example">
              <PaginationItem disabled={currentPage === 0}>
                <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, 0)} href="#">
                  {`‹‹‹`}
                </PaginationLink>
              </PaginationItem>

              <PaginationItem disabled={currentPage <= 0}>
                <PaginationLink
                  style={{ color: '#000' }}
                  onClick={e => this.handleClick(e, currentPage - 1)}
                  previous
                  href="#"
                />
              </PaginationItem>

              {[...Array(pagesCount)].map((page, i) => {
                if (i > currentPage - 3 && i < currentPage + 3) {
                  return (
                    <PaginationItem active={i === currentPage} key={page}>
                      <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, i)} href="#">
                        {i + 1}
                      </PaginationLink>
                    </PaginationItem>
                  );
                }

                return null;
              })}

              <PaginationItem disabled={currentPage >= pagesCount - 1}>
                <PaginationLink
                  style={{ color: '#000' }}
                  onClick={e => this.handleClick(e, currentPage + 1)}
                  next
                  href="#"
                />
              </PaginationItem>

              <PaginationItem disabled={currentPage >= pagesCount - 1}>
                <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, pagesCount - 1)} href="#">
                  {`›››`}
                </PaginationLink>
              </PaginationItem>
            </Pagination>
          </div>
          )}
        </Fragment>
      );
    }
  }

  render() {
    const { t } = this.props;

    return (
      <Fragment>
        <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-admin-action-logs">
          <PopoverBody className="popover-body">
            A list of almost all actions done by the administration in the admin panel. Currently, the data are being kept forever.
          </PopoverBody>
        </UncontrolledPopover>

        <div className="admin-page-content">
          <h2>
            Admin Actions
            <Button className="admin-help-button" id="admin-help-button-admin-action-logs">
              ?
            </Button>
          </h2>
          <table style={{ width: '100%', fontSize: 14, tableLayout: 'fixed' }}>
            <colgroup>
              <col span="1" style={{ width: '10%' }} />
              <col span="1" style={{ width: '10%' }} />
              <col span="1" style={{ width: '15%' }} />
              <col span="1" style={{ width: '30%', maxWidth: '30%' }} />
              <col span="1" style={{ width: '15%' }} />
              <col span="1" style={{ width: '10%' }} />
              <col span="1" style={{ width: '10%' }} />
            </colgroup>
            <thead>
              <tr>
                <th className="allUsers-table-col">
                  Id
                </th>
                <th className="allUsers-table-col">
                  Name
                </th>
                <th className="allUsers-table-col">
                  Actions
                </th>
                <th className="allUsers-table-col" style={{ maxWidth: '30%' }}>
                  Content
                </th>
                <th className="allUsers-table-col">
                  Date
                </th>
                <th className="allUsers-table-col">
                  Player Id
                </th>
                <th className="allUsers-table-col">
                  Name
                </th>
              </tr>
            </thead>
            <tbody>
              {this.table()}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}

export default withTranslation('admin')(AdminActionLogs);
